import { Listener } from './Listener';
import { TrackingHandler } from '../TrackingHandler';
import { detectFormTest } from '../../helpers/detect-form-test';
import { generateUuid } from '../../helpers/strings';
export class ExternalTrackingListener extends Listener {
    externalTrackingInitialized = false;
    hasExternalTracking = false;
    pageReadyTracked = false;
    pageReady(eventId) {
        const trackingHandler = TrackingHandler.getInstance();
        if (trackingHandler.isInternalTest) {
            return;
        }
        if (!this.initExternalTracking()) {
            return;
        }
        if (this.pageReadyTracked) {
            return;
        }
        if (typeof window.extTracking['pageReady'] !== 'function') {
            return;
        }
        this.pageReadyTracked = true;
        try {
            window.extTracking['pageReady'](trackingHandler.viewId)();
        }
        catch { }
    }
    setConsent(eventId, essential, functional, marketing) {
        this.pageReady(eventId);
    }
    formSubmitResult(eventId, formName, submitData, statusCode, responseData) {
        if (statusCode < 200 || statusCode >= 300) {
            return;
        }
        if (formName.toLowerCase().includes('consent')) {
            return;
        }
        if (!responseData) {
            return;
        }
        if (!responseData.t) {
            return;
        }
        if (detectFormTest(submitData)) {
            return;
        }
        if (!this.initExternalTracking()) {
            return;
        }
        if (typeof window.extTracking['formSubmit'] === 'function') {
            try {
                window.extTracking['formSubmit'](formName, submitData['submit_id_c'] || generateUuid())();
            }
            catch { }
            return;
        }
        if (typeof window.extTracking['formSubmit'] === 'string' && window.extTracking['formSubmit']) {
            const trackingPixel = new Image();
            trackingPixel.src = window.extTracking['formSubmit'];
        }
    }
    softConversion(eventId, source) {
        if (!this.initExternalTracking()) {
            return;
        }
        if (typeof window.extTracking['softConversion'] === 'function') {
            try {
                window.extTracking['softConversion'](source)();
            }
            catch { }
            return;
        }
        if (typeof window.extTracking['softConversion'] === 'string' && window.extTracking['softConversion']) {
            const trackingPixel = new Image();
            trackingPixel.src = window.extTracking['softConversion'];
        }
    }
    initExternalTracking() {
        if (!TrackingHandler.getInstance().consent.marketing) {
            return false;
        }
        if (this.externalTrackingInitialized) {
            return this.hasExternalTracking;
        }
        this.externalTrackingInitialized = true;
        if (typeof window.extTracking !== 'object') {
            return false;
        }
        this.hasExternalTracking = true;
        if (typeof window.extTracking['init'] === 'function') {
            try {
                window.extTracking['init']()();
            }
            catch { }
        }
        return true;
    }
}
